import React from 'react';
import _TradeNewsContainer from './_TradeNewsContainer.scss';
import TradeNewsItem from 'components/partials/tradenews';
import {Articles} from 'api';
import {Link} from 'react-router-dom';

class TradeNewsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 2,
      order: 'id DESC',
      categoryId: '5a04822ff75c7330ed575c09'
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          categoryId: this.state.categoryId
        }
      }
    }
    Articles.actions.list.request(params).then(response => {
      this.setState({
        data: response.data
      })
    });
  }

  render() {
    return (
      <section className='trade-category-container'>
        <div className='trade-category-wrap'>
          <div className='trade-left-content'>
            <p className='title-black'><Link to={`/news-category/${this.state.categoryId}`}>Thông tin - Sự kiện - Thông báo</Link></p>
          </div>
          <div className='trade-right-content'>
            {
              this.state.data.map((item,i) => {
                return(
                  <div key={i}>
                    <TradeNewsItem {...item}/>
                  </div>
                )
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default TradeNewsContainer;



// WEBPACK FOOTER //
// ./components/home/sub-view/TradeNewsContainer.jsx